import { Navigate, Outlet } from 'react-router-dom';
import { tokenManager } from '../api/tokenManager';

const ProtectedRoute = () => {
  const access = tokenManager.get('accessToken');
  if (!access) {
    return <Navigate to="/login" replace />;
  }
  return <Outlet />;
};

export default ProtectedRoute;
